export default __webpack_public_path__ + "static/f19-d1717cf63653fcb627af987ee893543f.svg";